import { useLocation,useNavigate } from 'react-router-dom';
import { useState,useEffect } from 'react';
import { FormGroup, FormControlLabel, Checkbox, Button, TextField } from '@mui/material';
import apiClient from '../ApiClient/ApiClient';
import { PERMISSION_COLUMNS, PERMISSION_GROUPS } from './permissionConfig';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export default function EditOrDeleteUserPage () {
  const location = useLocation();
  const [data , setUserData] = useState(null);
  const [id, setId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [bom1, setBom1] = useState(false);
  const [bom2, setBom2] = useState(false);
  const [bom3, setBom3] = useState(false);
  const [engineering1, setEngineering1] = useState(false);
  const [engineering2, setEngineering2] = useState(false);
  const [engineering3, setEngineering3] = useState(false);
  const [shipOrderTop1, setShipOrderTop1] = useState(false);
  const [shipOrderTop3, setShipOrderTop3] = useState(false);
  const [shipOrderBottom1, setShipOrderBottom1] = useState(false);
  const [shipDetail3, setShipDetail3] = useState(false);
  const [taiCheckBill3, setTaiCheckBill3] = useState(false);
  const [taiCheckBill1, setTaiCheckBill1] = useState(false);
  const [signSelect3, setSignSelect3] = useState(false);
  const [matCardDetail3, setMatCardDetail3] = useState(false);
  const [matCardStatistics3, setMatCardStatistics3] = useState(false);
  const [matCardStatistics2, setMatCardStatistics2] = useState(false);
  const [matCard3, setMatCard3] = useState(false);
  const [matCard2, setMatCard2] = useState(false);
  const [printBuy3, setPrintBuy3] = useState(false);
  const [materialParam1, setMaterialParam1] = useState(false);
  const [materialParam2, setMaterialParam2] = useState(false);
  const [materialParam3, setMaterialParam3] = useState(false);
  const [orderByHand1, setOrderByHand1] = useState(false);
  const [orderByExcel1, setOrderByExcel1] = useState(false);
  const [stockChange1, setStockChange1] = useState(false);
  const [stockChange3, setStockChange3] = useState(false);
  const [stockChange4, setStockChange4] = useState(false);
  const [itemSet1, setItemSet1] = useState(false);
  const [sellPrice1, setSellPrice1] = useState(false);
  const [sellPrice2, setSellPrice2] = useState(false);
  const [sellPrice3, setSellPrice3] = useState(false);
  const [purchaseInStockWork1, setPurchaseInStockWork1] = useState(false);
  const [purchaseInStockWork2, setPurchaseInStockWork2] = useState(false);
  const [purchaseInStockWork3, setPurchaseInStockWork3] = useState(false);
  const [purchaseInStockDetail2, setPurchaseInStockDetail2] = useState(false);
  const [purchaseInStockDetail3, setPurchaseInStockDetail3] = useState(false);
  const [purchaseInStockStatistics2, setPurchaseInStockStatistics2] = useState(false);
  const [purchaseInStockStatistics3, setPurchaseInStockStatistics3] = useState(false);
  const [launchProduction1, setLaunchProduction1] = useState(false);
  const [billTotalView3, setBillTotalView3] = useState(false);
  const [purchasePrice1, setPurchasePrice1] = useState(false);
  const [purchasePrice2, setPurchasePrice2] = useState(false);
  const [purchasePrice3, setPurchasePrice3] = useState(false);
  const [makeCmd2, setMakeCmd2] = useState(false);
  const [manufacturer1, setManufacturer1] = useState(false);
  const [manufacturer2, setManufacturer2] = useState(false);
  const [manufacturer3, setManufacturer3] = useState(false);
  const [purchaseWillInStock3, setPurchaseWillInStock3] = useState(false);
  const [purchaseBill3, setPurchaseBill3] = useState(false);
  const [purchaseBill1, setPurchaseBill1] = useState(false);
  const [purchaseSignIn4, setPurchaseSignIn4] = useState(false);
  const [machineSet1, setMachineSet1] = useState(false);
  const [machineSet2, setMachineSet2] = useState(false);
  const [machineSet3, setMachineSet3] = useState(false);
  const [shouldPay1, setShouldPay1] = useState(false);
  const [shouldPay2, setShouldPay2] = useState(false);
  const [shouldPay3, setShouldPay3] = useState(false);
  const [shouldGet1, setShouldGet1] = useState(false);
  const [shouldGet3, setShouldGet3] = useState(false);
  const [shouldGetTotal1, setShouldGetTotal1] = useState(false);
  const [shouldGetTotal3, setShouldGetTotal3] = useState(false);
  const [shouldGetBillTop1, setShouldGetBillTop1] = useState(false);
  const [shouldGetBillBottom1, setShouldGetBillBottom1] = useState(false);
  const [shouldGetBillBottom2, setShouldGetBillBottom2] = useState(false);
  const [shouldGetBillBottom3, setShouldGetBillBottom3] = useState(false);
  const [workPlace1, setWorkPlace1] = useState(false);
  const [workPlace2, setWorkPlace2] = useState(false);
  const [workPlace3, setWorkPlace3] = useState(false);
  const [signInSelect3, setSignInSelect3] = useState(false);
  const [checkStockInDetail3, setCheckStockInDetail3] = useState(false);
  const [canCruduser, setCanCruduser] = useState(false);
  const [itemSet2, setItemSet2] = useState(false);
  const [approval, setApproval] = useState(false);
  const [productionReportView, setProductionReportView] = useState(false);
  const [productionReportCreate, setProductionReportCreate] = useState(false);
  const [productionReportUpdate, setProductionReportUpdate] = useState(false);
  const [productionReportDelete, setProductionReportDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [permissionSearch, setPermissionSearch] = useState('');
  const [onlyGranted, setOnlyGranted] = useState(false);
  const [permissionsDirty, setPermissionsDirty] = useState(false);
  const showLegacyPermissionList = false;
  const routeState = location.state || {};
  const userName = routeState.userName || 'new';
  const beUpdateId = routeState.id ;
  const [formData, setFormData] = useState({
    company: '',
    uid: '',
    pwd: '',
    userName: '',
    role: '',
    status: '1',
    verified: '1',
    id:'0'
  });
  const navigate = useNavigate();

  const permissionBindings = {
    productionReportView: [productionReportView, setProductionReportView],
    productionReportCreate: [productionReportCreate, setProductionReportCreate],
    productionReportUpdate: [productionReportUpdate, setProductionReportUpdate],
    productionReportDelete: [productionReportDelete, setProductionReportDelete],
    bom1: [bom1, setBom1], bom2: [bom2, setBom2], bom3: [bom3, setBom3],
    engineering1: [engineering1, setEngineering1], engineering2: [engineering2, setEngineering2], engineering3: [engineering3, setEngineering3],
    shipOrderTop1: [shipOrderTop1, setShipOrderTop1], shipOrderTop3: [shipOrderTop3, setShipOrderTop3], shipOrderBottom1: [shipOrderBottom1, setShipOrderBottom1],
    shipDetail3: [shipDetail3, setShipDetail3], taiCheckBill3: [taiCheckBill3, setTaiCheckBill3], taiCheckBill1: [taiCheckBill1, setTaiCheckBill1],
    signSelect3: [signSelect3, setSignSelect3], matCardDetail3: [matCardDetail3, setMatCardDetail3],
    matCardStatistics3: [matCardStatistics3, setMatCardStatistics3], matCardStatistics2: [matCardStatistics2, setMatCardStatistics2],
    matCard3: [matCard3, setMatCard3], matCard2: [matCard2, setMatCard2], printBuy3: [printBuy3, setPrintBuy3],
    materialParam1: [materialParam1, setMaterialParam1], materialParam2: [materialParam2, setMaterialParam2], materialParam3: [materialParam3, setMaterialParam3],
    orderByHand1: [orderByHand1, setOrderByHand1], orderByExcel1: [orderByExcel1, setOrderByExcel1],
    stockChange1: [stockChange1, setStockChange1], stockChange3: [stockChange3, setStockChange3], stockChange4: [stockChange4, setStockChange4],
    itemSet1: [itemSet1, setItemSet1], itemSet2: [itemSet2, setItemSet2],
    sellPrice1: [sellPrice1, setSellPrice1], sellPrice2: [sellPrice2, setSellPrice2], sellPrice3: [sellPrice3, setSellPrice3],
    purchaseInStockWork1: [purchaseInStockWork1, setPurchaseInStockWork1], purchaseInStockWork2: [purchaseInStockWork2, setPurchaseInStockWork2], purchaseInStockWork3: [purchaseInStockWork3, setPurchaseInStockWork3],
    purchaseInStockDetail2: [purchaseInStockDetail2, setPurchaseInStockDetail2], purchaseInStockDetail3: [purchaseInStockDetail3, setPurchaseInStockDetail3],
    purchaseInStockStatistics2: [purchaseInStockStatistics2, setPurchaseInStockStatistics2], purchaseInStockStatistics3: [purchaseInStockStatistics3, setPurchaseInStockStatistics3],
    launchProduction1: [launchProduction1, setLaunchProduction1], billTotalView3: [billTotalView3, setBillTotalView3],
    purchasePrice1: [purchasePrice1, setPurchasePrice1], purchasePrice2: [purchasePrice2, setPurchasePrice2], purchasePrice3: [purchasePrice3, setPurchasePrice3],
    makeCmd2: [makeCmd2, setMakeCmd2], manufacturer1: [manufacturer1, setManufacturer1], manufacturer2: [manufacturer2, setManufacturer2], manufacturer3: [manufacturer3, setManufacturer3],
    purchaseWillInStock3: [purchaseWillInStock3, setPurchaseWillInStock3], purchaseBill3: [purchaseBill3, setPurchaseBill3], purchaseBill1: [purchaseBill1, setPurchaseBill1], purchaseSignIn4: [purchaseSignIn4, setPurchaseSignIn4],
    machineSet1: [machineSet1, setMachineSet1], machineSet2: [machineSet2, setMachineSet2], machineSet3: [machineSet3, setMachineSet3],
    shouldPay1: [shouldPay1, setShouldPay1], shouldPay2: [shouldPay2, setShouldPay2], shouldPay3: [shouldPay3, setShouldPay3],
    shouldGet1: [shouldGet1, setShouldGet1], shouldGet3: [shouldGet3, setShouldGet3], shouldGetTotal1: [shouldGetTotal1, setShouldGetTotal1], shouldGetTotal3: [shouldGetTotal3, setShouldGetTotal3],
    shouldGetBillTop1: [shouldGetBillTop1, setShouldGetBillTop1], shouldGetBillBottom1: [shouldGetBillBottom1, setShouldGetBillBottom1], shouldGetBillBottom2: [shouldGetBillBottom2, setShouldGetBillBottom2], shouldGetBillBottom3: [shouldGetBillBottom3, setShouldGetBillBottom3],
    workPlace1: [workPlace1, setWorkPlace1], workPlace2: [workPlace2, setWorkPlace2], workPlace3: [workPlace3, setWorkPlace3],
    signInSelect3: [signInSelect3, setSignInSelect3], checkStockInDetail3: [checkStockInDetail3, setCheckStockInDetail3],
    canCruduser: [canCruduser, setCanCruduser], approval: [approval, setApproval],
  };


  useEffect(() => {
    // 如果 userName 是 'new'，則直接返回，不調用 API
    if (userName === 'new') {
      // Set formData to its initial state
      setFormData({
        company: '',
        uid: '',
        pwd: '',
        userName: '',
        role: '',
        status: '1',
        verified: '1',
        id: '0'
      });
      return;
    }
  
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get(`/User/GetMain?user=${beUpdateId}`);
        const authresponse = await apiClient.get(`/User/Auth?userId=${parseInt(beUpdateId,10)}`);
        const authData = authresponse.data || {};
        setId(authData.id);
        setUserId(authData.userId);
        setBom1(authData.bom1);
        setBom2(authData.bom2);
        setBom3(authData.bom3);
        setEngineering1(authData.engineering1);
        setEngineering2(authData.engineering2);
        setEngineering3(authData.engineering3);
        setShipOrderTop1(authData.shipOrderTop1);
        setShipOrderTop3(authData.shipOrderTop3);
        setShipOrderBottom1(authData.shipOrderBottom1);
        setShipDetail3(authData.shipDetail3);
        setTaiCheckBill3(authData.taiCheckBill3);
        setTaiCheckBill1(authData.taiCheckBill1);
        setSignSelect3(authData.signSelect3);
        setMatCardDetail3(authData.matCardDetail3);
        setMatCardStatistics3(authData.matCardStatistics3);
        setMatCardStatistics2(authData.matCardStatistics2);
        setMatCard3(authData.matCard3);
        setMatCard2(authData.matCard2);
        setPrintBuy3(authData.printBuy3);
        setMaterialParam1(authData.materialParam1);
        setMaterialParam2(authData.materialParam2);
        setMaterialParam3(authData.materialParam3);
        setOrderByHand1(authData.orderByHand1);
        setOrderByExcel1(authData.orderByExcel1);
        setStockChange1(authData.stockChange1);
        setStockChange3(authData.stockChange3);
        setStockChange4(authData.stockChange4);
        setItemSet1(authData.itemSet1);
        setSellPrice1(authData.sellPrice1);
        setSellPrice2(authData.sellPrice2);
        setSellPrice3(authData.sellPrice3);
        setPurchaseInStockWork1(authData.purchaseInStockWork1);
        setPurchaseInStockWork2(authData.purchaseInStockWork2);
        setPurchaseInStockWork3(authData.purchaseInStockWork3);
        setPurchaseInStockDetail2(authData.purchaseInStockDetail2);
        setPurchaseInStockDetail3(authData.purchaseInStockDetail3);
        setPurchaseInStockStatistics2(authData.purchaseInStockStatistics2);
        setPurchaseInStockStatistics3(authData.purchaseInStockStatistics3);
        setLaunchProduction1(authData.launchProduction1);
        setBillTotalView3(authData.billTotalView3);
        setPurchasePrice1(authData.purchasePrice1);
        setPurchasePrice2(authData.purchasePrice2);
        setPurchasePrice3(authData.purchasePrice3);
        setMakeCmd2(authData.makeCmd2);
        setManufacturer1(authData.manufacturer1);
        setManufacturer2(authData.manufacturer2);
        setManufacturer3(authData.manufacturer3);
        setPurchaseWillInStock3(authData.purchaseWillInStock3);
        setPurchaseBill3(authData.purchaseBill3);
        setPurchaseBill1(authData.purchaseBill1);
        setPurchaseSignIn4(authData.purchaseSignIn4);
        setMachineSet1(authData.machineSet1);
        setMachineSet2(authData.machineSet2);
        setMachineSet3(authData.machineSet3);
        setShouldPay1(authData.shouldPay1);
        setShouldPay2(authData.shouldPay2);
        setShouldPay3(authData.shouldPay3);
        setShouldGet1(authData.shouldGet1);
        setShouldGet3(authData.shouldGet3);
        setShouldGetTotal1(authData.shouldGetTotal1);
        setShouldGetTotal3(authData.shouldGetTotal3);
        setShouldGetBillTop1(authData.shouldGetBillTop1);
        setShouldGetBillBottom1(authData.shouldGetBillBottom1);
        setShouldGetBillBottom2(authData.shouldGetBillBottom2);
        setShouldGetBillBottom3(authData.shouldGetBillBottom3);
        setWorkPlace1(authData.workPlace1);
        setWorkPlace2(authData.workPlace2);
        setWorkPlace3(authData.workPlace3);
        setSignInSelect3(authData.signInSelect3);
        setCheckStockInDetail3(authData.checkStockInDetail3);
        setCanCruduser(authData.canCruduser);
        setItemSet2(authData.itemSet2);
        setApproval(authData.approval);
        setProductionReportView(Boolean(authData.productionReportView));
        setProductionReportCreate(Boolean(authData.productionReportCreate));
        setProductionReportUpdate(Boolean(authData.productionReportUpdate));
        setProductionReportDelete(Boolean(authData.productionReportDelete));
        setPermissionsDirty(false);

        setUserData(response.data.user);
        // 设置formData的状态
        setFormData({
          company: response.data.user ? response.data.user.company : '',
          uid: response.data.user ? response.data.user.uid : '',
          pwd: response.data.user ? response.data.user.pwd : '',
          userName: response.data.user ? response.data.user.userName : '',
          role: response.data.user ? response.data.user.role : '',
          status: response.data.user ? String(response.data.user.status ?? 1) : '1',
          verified: response.data.user ? String(response.data.user.verified ?? 1) : '1',
          id: response.data.user ? response.data.user.id.toString() : '0',
        });
        setLoading(false);
  
      } catch (error) {
        console.error('Failed to fetch user data:', error);
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userName]);

  useEffect(() => {
    const warnBeforeUnload = (event) => {
      if (!permissionsDirty) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warnBeforeUnload);
    return () => window.removeEventListener('beforeunload', warnBeforeUnload);
  }, [permissionsDirty]);

  const updatePermissions = (updates) => {
    let changed = false;
    Object.entries(updates).forEach(([key, nextValue]) => {
      const binding = permissionBindings[key];
      if (!binding) return;
      const [currentValue, setter] = binding;
      const normalizedValue = Boolean(nextValue);
      if (Boolean(currentValue) !== normalizedValue) {
        setter(normalizedValue);
        changed = true;
      }
    });
    if (changed) setPermissionsDirty(true);
  };

  const handlePermissionChange = (row, columnKey, checked) => {
    const permissionKey = row.permissions[columnKey];
    if (!permissionKey) return;
    const updates = { [permissionKey]: checked };

    // 編輯、刪除或審核一定需要先能查看該功能。
    if (checked && columnKey !== 'view' && row.permissions.view) {
      updates[row.permissions.view] = true;
    }

    if (!checked && columnKey === 'view') {
      const dependentKeys = ['edit', 'delete', 'approve']
        .map((key) => row.permissions[key])
        .filter((key) => key && permissionBindings[key]?.[0]);
      if (dependentKeys.length > 0) {
        const confirmed = window.confirm('取消查看權限會一併取消這項功能的編輯、刪除與審核權限，確定繼續？');
        if (!confirmed) return;
        dependentKeys.forEach((key) => { updates[key] = false; });
      }
    }

    updatePermissions(updates);
  };

  const applyGroupPermission = (group, mode) => {
    if (mode === 'all' && !window.confirm(`確定要開啟「${group.title}」的全部權限？這可能包含刪除或審核權限。`)) return;
    const updates = {};
    group.rows.forEach((row) => {
      Object.entries(row.permissions).forEach(([columnKey, permissionKey]) => {
        if (mode === 'readonly') updates[permissionKey] = columnKey === 'view';
        if (mode === 'all') updates[permissionKey] = true;
        if (mode === 'none') updates[permissionKey] = false;
      });
    });
    updatePermissions(updates);
  };

  const normalizedPermissionSearch = permissionSearch.trim().toLocaleLowerCase('zh-Hant-TW');
  const visiblePermissionGroups = PERMISSION_GROUPS.map((group) => ({
    ...group,
    rows: group.rows.filter((row) => {
      const matchesSearch = !normalizedPermissionSearch
        || `${group.title} ${row.label}`.toLocaleLowerCase('zh-Hant-TW').includes(normalizedPermissionSearch);
      const hasGrantedPermission = Object.values(row.permissions)
        .some((key) => Boolean(permissionBindings[key]?.[0]));
      return matchesSearch && (!onlyGranted || hasGrantedPermission);
    }),
  })).filter((group) => group.rows.length > 0);

  const handleCheckboxChange = (setter) => (event) => {
    setter(event.target.checked);
  };
  console.log(formData)
  // 發送修改後的數據到後端
  const handleSave = async () => {
    try {
      const updateData = {
        Id: id,
        UserId: userId,
        Bom1: bom1,
        Bom2: bom2,
        Bom3: bom3,
        Engineering1: engineering1,
        Engineering2: engineering2,
        Engineering3: engineering3,
        ShipOrderTop1: shipOrderTop1,
        ShipOrderTop3: shipOrderTop3,
        ShipOrderBottom1: shipOrderBottom1,
        ShipDetail3: shipDetail3,
        TaiCheckBill3: taiCheckBill3,
        TaiCheckBill1: taiCheckBill1,
        SignSelect3: signSelect3,
        MatCardDetail3: matCardDetail3,
        MatCardStatistics3: matCardStatistics3,
        MatCardStatistics2: matCardStatistics2,
        MatCard3: matCard3,
        MatCard2: matCard2,
        PrintBuy3: printBuy3,
        MaterialParam1: materialParam1,
        MaterialParam2: materialParam2,
        MaterialParam3: materialParam3,
        OrderByHand1: orderByHand1,
        OrderByExcel1: orderByExcel1,
        StockChange1: stockChange1,
        StockChange3: stockChange3,
        StockChange4: stockChange4,
        ItemSet1: itemSet1,
        SellPrice1: sellPrice1,
        SellPrice2: sellPrice2,
        SellPrice3: sellPrice3,
        PurchaseInStockWork1: purchaseInStockWork1,
        PurchaseInStockWork2: purchaseInStockWork2,
        PurchaseInStockWork3: purchaseInStockWork3,
        PurchaseInStockDetail2: purchaseInStockDetail2,
        PurchaseInStockDetail3: purchaseInStockDetail3,
        PurchaseInStockStatistics2: purchaseInStockStatistics2,
        PurchaseInStockStatistics3: purchaseInStockStatistics3,
        LaunchProduction1: launchProduction1,
        BillTotalView3: billTotalView3,
        PurchasePrice1: purchasePrice1,
        PurchasePrice2: purchasePrice2,
        PurchasePrice3: purchasePrice3,
        MakeCmd2: makeCmd2,
        Manufacturer1: manufacturer1,
        Manufacturer2: manufacturer2,
        Manufacturer3: manufacturer3,
        PurchaseWillInStock3: purchaseWillInStock3,
        PurchaseBill3: purchaseBill3,
        PurchaseBill1: purchaseBill1,
        PurchaseSignIn4: purchaseSignIn4,
        MachineSet1: machineSet1,
        MachineSet2: machineSet2,
        MachineSet3: machineSet3,
        ShouldPay1: shouldPay1,
        ShouldPay2: shouldPay2,
        ShouldPay3: shouldPay3,
        ShouldGet1: shouldGet1,
        ShouldGet3: shouldGet3,
        ShouldGetTotal1: shouldGetTotal1,
        ShouldGetTotal3: shouldGetTotal3,
        ShouldGetBillTop1: shouldGetBillTop1,
        ShouldGetBillBottom1: shouldGetBillBottom1,
        ShouldGetBillBottom2: shouldGetBillBottom2,
        ShouldGetBillBottom3: shouldGetBillBottom3,
        WorkPlace1: workPlace1,
        WorkPlace2: workPlace2,
        WorkPlace3: workPlace3,
        SignInSelect3: signInSelect3,
        CheckStockInDetail3: checkStockInDetail3,
        CanCruduser: canCruduser,
        ItemSet2: itemSet2,
        Approval: approval,
        ProductionReportView: productionReportView,
        ProductionReportCreate: productionReportCreate,
        ProductionReportUpdate: productionReportUpdate,
        ProductionReportDelete: productionReportDelete,
      };
      await apiClient.put(`/User/Auth`, updateData);
      alert('數據已成功保存');
      setPermissionsDirty(false);
    } catch (error) {
      console.error('Error updating data:', error);
      alert('保存數據時出錯');
    }
  };

  const handleSubmit = async (event) => {
    if(userName !== 'new') {
        try {
            event.preventDefault(); // 防止表單預設提交行為
        
            // 使用一個區域變數存儲當前的 formData 值
            const currentFormData = {
              ...formData,
              status: Number(formData.status),
              verified: Number(formData.verified),
            };
        
            // 使用你的API URL
            const response = await apiClient.post(`/User/EditMain`, currentFormData);
        
            if (response.data.statusCode === 200) {
              // 处理响应
              console.log('Data successfully submitted');
              alert('修改成功')
              setUserData(response.data.user)
            } else {
              alert('修改失敗 請確認欄位值');
            }
          } catch (error) {
            console.error('There was an error!', error);
          }
    }else {
        try {
            event.preventDefault(); // 防止表單預設提交行為
        
            // 使用一個區域變數存儲當前的 formData 值
            const currentFormData = {
              ...formData,
              status: Number(formData.status),
              verified: Number(formData.verified),
            };
            console.log(currentFormData)
        
            // 使用你的API URL
            const response = await apiClient.post(`/User/CreateMain`, currentFormData);
        
            if (response.data.statusCode === 200) {
              // 处理响应
              console.log('Data successfully submitted');
              alert('新增成功')
              setUserData(response.data.user)
              if (response.data.user?.id) {
                navigate('/dashboard/EditOrDeleteUserPage', {
                  state: { userName: response.data.user.userName, id: response.data.user.id },
                  replace: true
                });
              }
            } else {
              alert('新增失敗 請確認欄位值');
            }
          } catch (error) {
            console.error('There was an error!', error);
          }
    }
    
  };
  

const handleInputChange = (event) => {
    const { id, value } = event.target;
    setFormData(prevState => ({
        ...prevState,
        [id]: value
    }));       
};
const handleBack =() => {
    if (permissionsDirty && !window.confirm('權限設定尚未保存，確定要離開？')) return;
    navigate('/dashboard/user', { 
        replace: true 
      });
}
return(
  <>
    {loading ? (
      <div className='container-fluid'>
        {/* You can replace this div with a loading spinner or something else */}
        <div>Loading...</div>
      </div>
    ) : (
      <form onSubmit={handleSubmit}>
        <div className='container-fluid'>
            <div className='row mb-3'>
                <div className='col-5'/>
                <div className='col-2'>
                    <h2><span className="badge bg-success">編輯使用者</span></h2>
                </div>
                <div className='col-5'/>
            </div>           
            <div className='row mb-3'>
                <div className='col-3'/>
                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                    <span>Uid Account</span>
                </div>
                <div className='col-2 ps-0'>
                    <input type="text" id="uid" className="form-control" aria-describedby="passwordHelpInline"
                    value = {formData.uid|| ""}
                    onChange={handleInputChange}/>
                </div>
                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                    <span>PassWord</span>
                </div>
                <div className='col-2  ps-0'>
                    <input type="text" id="pwd" className="form-control" aria-describedby="passwordHelpInline"
                    value = {formData.pwd|| ""}
                    onChange={handleInputChange}/>
                </div>
            </div>
            <div className='row mb-3'>
                <div className='col-3'/>
                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                    <span>Company</span>
                </div>
                <div className='col-2 ps-0'>
                    <select id="company" className="form-control" aria-describedby="passwordHelpInline"
                        value = {formData.company|| ""}
                        onChange={handleInputChange}>
                        <option value="">請選擇</option>
                        <option value="FM">FM</option>
                        <option value="HC">HC</option>
                    </select>
                </div>
                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                    <span>UserName</span>
                </div>
                <div className='col-2  ps-0'>
                <input type="text" id="userName" className="form-control" aria-describedby="passwordHelpInline"
                        value = {formData.userName|| ""}
                        onChange={handleInputChange}/>
                </div>
            </div>
            <div className='row mb-3'>
                <div className='col-3'/>
                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                    <span>Role</span>
                </div>
                <div className='col-2 ps-0'>
                    <input type="text" id="role" className="form-control" aria-describedby="passwordHelpInline"
                        value = {formData.role|| ""}
                        onChange={handleInputChange}/>
                </div>
                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                    <span>Status</span>
                </div>
                <div className='col-2 ps-0'>
                    <select id="status" className="form-control" aria-describedby="passwordHelpInline"
                        value = {formData.status|| "1"}
                        onChange={handleInputChange}>
                        <option value="1">啟用</option>
                        <option value="0">停用</option>
                    </select>
                </div>
            </div>
            <div className='row mb-3'>
                <div className='col-3'/>
                <div className='col-1 px-0 d-flex align-items-center' style={{textAlign: 'center'}}>
                    <span>Verified</span>
                </div>
                <div className='col-2 ps-0'>
                    <select id="verified" className="form-control" aria-describedby="passwordHelpInline"
                        value = {formData.verified|| "1"}
                        onChange={handleInputChange}>
                        <option value="1">已驗證</option>
                        <option value="0">未驗證</option>
                    </select>
                </div>
            </div>
            <div className='row'>
                <div className='col-12 d-flex justify-content-center'>
                    <button type="submit" className="btn btn-dark">提交</button>
                    <span style={{ marginLeft: '10px' }}/>
                    <button type="button" className="btn btn-dark" onClick={handleBack}>返回</button>
                </div>
            </div>
        </div>
      </form>
    )}    
    {userName !== 'new' && (
      <section style={{ maxWidth: '1500px', margin: '24px auto', padding: '0 16px 88px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
          <div>
            <h2 style={{ marginBottom: '4px' }}>權限設定</h2>
            <div style={{ color: '#607d8b' }}>
              <span style={{ marginRight: '16px' }}>帳號：{formData.uid || '-'}</span>
              <span style={{ marginRight: '16px' }}>姓名：{formData.userName || '-'}</span>
              <span>公司：{formData.company || '-'}</span>
            </div>
          </div>
          <div style={{ color: permissionsDirty ? '#d32f2f' : '#2e7d32', fontWeight: 700 }}>
            {permissionsDirty ? '尚未保存' : '已保存'}
          </div>
        </div>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '16px' }}>
          <TextField
            label="搜尋功能或權限"
            value={permissionSearch}
            onChange={(event) => setPermissionSearch(event.target.value)}
            size="small"
            sx={{ minWidth: 300 }}
          />
          <FormControlLabel
            control={<Checkbox checked={onlyGranted} onChange={(event) => setOnlyGranted(event.target.checked)} />}
            label="只顯示已授權"
          />
          <span style={{ color: '#607d8b' }}>
            勾選編輯、刪除或審核時，系統會自動加上對應的查看權限。
          </span>
        </div>

        {visiblePermissionGroups.length === 0 && (
          <div style={{ padding: '32px', textAlign: 'center', color: '#607d8b', border: '1px solid #e0e0e0', borderRadius: '8px' }}>
            找不到符合條件的權限。
          </div>
        )}

        {visiblePermissionGroups.map((group) => (
          <details key={group.id} open style={{ marginBottom: '12px', border: '1px solid #d7dee5', borderRadius: '8px', overflow: 'hidden', background: '#fff' }}>
            <summary style={{ cursor: 'pointer', padding: '14px 16px', fontWeight: 700, background: '#f5f7fa' }}>
              {group.title}
            </summary>
            <div style={{ padding: '12px 16px' }}>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', flexWrap: 'wrap', marginBottom: '10px' }}>
                <Button size="small" variant="outlined" onClick={() => applyGroupPermission(group, 'readonly')}>全部唯讀</Button>
                <Button size="small" variant="outlined" color="warning" onClick={() => applyGroupPermission(group, 'all')}>全部授權</Button>
                <Button size="small" variant="outlined" color="error" onClick={() => applyGroupPermission(group, 'none')}>全部取消</Button>
              </div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '720px' }}>
                  <thead>
                    <tr style={{ background: '#fafafa' }}>
                      <th style={{ textAlign: 'left', padding: '10px', borderBottom: '1px solid #e0e0e0', width: '40%' }}>功能</th>
                      {PERMISSION_COLUMNS.map((column) => (
                        <th key={column.key} style={{ textAlign: 'center', padding: '10px', borderBottom: '1px solid #e0e0e0' }}>{column.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {group.rows.map((row) => (
                      <tr key={row.label}>
                        <td style={{ padding: '8px 10px', borderBottom: '1px solid #eeeeee', fontWeight: 600 }}>{row.label}</td>
                        {PERMISSION_COLUMNS.map((column) => {
                          const permissionKey = row.permissions[column.key];
                          const checked = permissionKey ? Boolean(permissionBindings[permissionKey]?.[0]) : false;
                          const actionLabel = column.key === 'delete' ? row.deleteLabel : column.key === 'approve' ? row.specialLabel : null;
                          return (
                            <td key={column.key} style={{ padding: '4px 10px', borderBottom: '1px solid #eeeeee', textAlign: 'center' }}>
                              {permissionKey ? (
                                <FormControlLabel
                                  sx={{ margin: 0 }}
                                  control={(
                                    <Checkbox
                                      checked={checked}
                                      color={column.key === 'delete' ? 'error' : column.key === 'approve' ? 'warning' : 'primary'}
                                      onChange={(event) => handlePermissionChange(row, column.key, event.target.checked)}
                                    />
                                  )}
                                  label={actionLabel || ''}
                                />
                              ) : '—'}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </details>
        ))}

        <div style={{ position: 'sticky', bottom: 0, display: 'flex', justifyContent: 'flex-end', gap: '12px', padding: '14px 16px', marginTop: '16px', background: 'rgba(255,255,255,0.96)', borderTop: '1px solid #d7dee5', boxShadow: '0 -4px 12px rgba(0,0,0,0.08)', zIndex: 5 }}>
          <Button variant="outlined" onClick={handleBack}>返回</Button>
          <Button variant="contained" onClick={handleSave} disabled={!permissionsDirty}>
            {permissionsDirty ? '保存權限變更' : '已保存'}
          </Button>
        </div>
      </section>
    )}
    {!showLegacyPermissionList ? null :
    <>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <h1>權限控管</h1>
        </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <FormGroup>
        <FormControlLabel
            control={<Checkbox checked={bom1} onChange={handleCheckboxChange(setBom1)} />}
            label="Bom編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={bom2} onChange={handleCheckboxChange(setBom2)} />}
            label="Bom刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={bom3} onChange={handleCheckboxChange(setBom3)} />}
            label="Bom搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={engineering1} onChange={handleCheckboxChange(setEngineering1)} />}
            label="工程名稱編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={engineering2} onChange={handleCheckboxChange(setEngineering2)} />}
            label="工程名稱刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={engineering3} onChange={handleCheckboxChange(setEngineering3)} />}
            label="工程名稱搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={shipOrderTop1} onChange={handleCheckboxChange(setShipOrderTop1)} />}
            label="出貨交運單上編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={shipOrderTop3} onChange={handleCheckboxChange(setShipOrderTop3)} />}
            label="出貨交運單上搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={shipOrderBottom1} onChange={handleCheckboxChange(setShipOrderBottom1)} />}
            label="出貨交運單下編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={shipDetail3} onChange={handleCheckboxChange(setShipDetail3)} />}
            label="出貨明細搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={taiCheckBill3} onChange={handleCheckboxChange(setTaiCheckBill3)} />}
            label="台日檢收票搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={taiCheckBill1} onChange={handleCheckboxChange(setTaiCheckBill1)} />}
            label="台日檢收票編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={signSelect3} onChange={handleCheckboxChange(setSignSelect3)} />}
            label="未簽核查詢搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={matCardDetail3} onChange={handleCheckboxChange(setMatCardDetail3)} />}
            label="生管資材卡名細表搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={matCardStatistics3} onChange={handleCheckboxChange(setMatCardStatistics3)} />}
            label="生管資材卡統計表搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={matCardStatistics2} onChange={handleCheckboxChange(setMatCardStatistics2)} />}
            label="生管資材卡統計表刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={matCard3} onChange={handleCheckboxChange(setMatCard3)} />}
            label="生管資材卡搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={matCard2} onChange={handleCheckboxChange(setMatCard2)} />}
            label="生管資材卡刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={printBuy3} onChange={handleCheckboxChange(setPrintBuy3)} />}
            label="列印請採購搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={materialParam1} onChange={handleCheckboxChange(setMaterialParam1)} />}
            label="材料系數編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={materialParam2} onChange={handleCheckboxChange(setMaterialParam2)} />}
            label="材料系數刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={materialParam3} onChange={handleCheckboxChange(setMaterialParam3)} />}
            label="材料系數搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={orderByHand1} onChange={handleCheckboxChange(setOrderByHand1)} />}
            label="訂單手輸編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={orderByExcel1} onChange={handleCheckboxChange(setOrderByExcel1)} />}
            label="訂單輸入編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={stockChange1} onChange={handleCheckboxChange(setStockChange1)} />}
            label="庫存異動調整編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={stockChange3} onChange={handleCheckboxChange(setStockChange3)} />}
            label="庫存異動調整搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={stockChange4} onChange={handleCheckboxChange(setStockChange4)} />}
            label="庫存異動調整審核"
          />
          <FormControlLabel
            control={<Checkbox checked={itemSet1} onChange={handleCheckboxChange(setItemSet1)} />}
            label="料品資料編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={itemSet2} onChange={handleCheckboxChange(setItemSet2)} />}
            label="料品資料刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={sellPrice1} onChange={handleCheckboxChange(setSellPrice1)} />}
            label="售價一覽表編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={sellPrice2} onChange={handleCheckboxChange(setSellPrice2)} />}
            label="售價一覽表刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={sellPrice3} onChange={handleCheckboxChange(setSellPrice3)} />}
            label="售價一覽表搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseInStockWork1} onChange={handleCheckboxChange(setPurchaseInStockWork1)} />}
            label="採購入庫作業編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseInStockWork2} onChange={handleCheckboxChange(setPurchaseInStockWork2)} />}
            label="採購入庫作業退庫"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseInStockWork3} onChange={handleCheckboxChange(setPurchaseInStockWork3)} />}
            label="採購入庫作業搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseInStockDetail2} onChange={handleCheckboxChange(setPurchaseInStockDetail2)} />}
            label="採購入庫明細表刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseInStockDetail3} onChange={handleCheckboxChange(setPurchaseInStockDetail3)} />}
            label="採購入庫明細表搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseInStockStatistics2} onChange={handleCheckboxChange(setPurchaseInStockStatistics2)} />}
            label="採購入庫統計表刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseInStockStatistics3} onChange={handleCheckboxChange(setPurchaseInStockStatistics3)} />}
            label="採購入庫統計表搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={launchProduction1} onChange={handleCheckboxChange(setLaunchProduction1)} />}
            label="發動生產"
          />
          <FormControlLabel
            control={<Checkbox checked={billTotalView3} onChange={handleCheckboxChange(setBillTotalView3)} />}
            label="發票總覽"
          />
          <FormControlLabel
            control={<Checkbox checked={purchasePrice1} onChange={handleCheckboxChange(setPurchasePrice1)} />}
            label="進價一覽表編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={purchasePrice2} onChange={handleCheckboxChange(setPurchasePrice2)} />}
            label="進價一覽表刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={purchasePrice3} onChange={handleCheckboxChange(setPurchasePrice3)} />}
            label="進價一覽表搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={makeCmd2} onChange={handleCheckboxChange(setMakeCmd2)} />}
            label="補印製令刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={manufacturer1} onChange={handleCheckboxChange(setManufacturer1)} />}
            label="廠商資料編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={manufacturer2} onChange={handleCheckboxChange(setManufacturer2)} />}
            label="廠商資料刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={manufacturer3} onChange={handleCheckboxChange(setManufacturer3)} />}
            label="廠商資料搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseWillInStock3} onChange={handleCheckboxChange(setPurchaseWillInStock3)} />}
            label="請採購預定入庫搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseBill3} onChange={handleCheckboxChange(setPurchaseBill3)} />}
            label="請採購單搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseBill1} onChange={handleCheckboxChange(setPurchaseBill1)} />}
            label="請採購單編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={purchaseSignIn4} onChange={handleCheckboxChange(setPurchaseSignIn4)} />}
            label="請採購簽核審核"
          />
          <FormControlLabel
            control={<Checkbox checked={machineSet1} onChange={handleCheckboxChange(setMachineSet1)} />}
            label="機台設定編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={machineSet2} onChange={handleCheckboxChange(setMachineSet2)} />}
            label="機台設定刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={machineSet3} onChange={handleCheckboxChange(setMachineSet3)} />}
            label="機台設定搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldPay1} onChange={handleCheckboxChange(setShouldPay1)} />}
            label="應付帳款編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldPay2} onChange={handleCheckboxChange(setShouldPay2)} />}
            label="應付帳款刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldPay3} onChange={handleCheckboxChange(setShouldPay3)} />}
            label="應付帳款搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGet1} onChange={handleCheckboxChange(setShouldGet1)} />}
            label="應收帳款編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGet3} onChange={handleCheckboxChange(setShouldGet3)} />}
            label="應收帳款搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGetTotal1} onChange={handleCheckboxChange(setShouldGetTotal1)} />}
            label="應收帳款總表編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGetTotal3} onChange={handleCheckboxChange(setShouldGetTotal3)} />}
            label="應收帳款總表搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGetBillTop1} onChange={handleCheckboxChange(setShouldGetBillTop1)} />}
            label="應收對帳單上編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGetBillBottom1} onChange={handleCheckboxChange(setShouldGetBillBottom1)} />}
            label="應收對帳單下編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGetBillBottom2} onChange={handleCheckboxChange(setShouldGetBillBottom2)} />}
            label="應收對帳單下刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={shouldGetBillBottom3} onChange={handleCheckboxChange(setShouldGetBillBottom3)} />}
            label="應收對帳單下搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={workPlace1} onChange={handleCheckboxChange(setWorkPlace1)} />}
            label="職場設定編輯"
          />
          <FormControlLabel
            control={<Checkbox checked={workPlace2} onChange={handleCheckboxChange(setWorkPlace2)} />}
            label="職場設定刪除"
          />
          <FormControlLabel
            control={<Checkbox checked={workPlace3} onChange={handleCheckboxChange(setWorkPlace3)} />}
            label="職場設定搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={signInSelect3} onChange={handleCheckboxChange(setSignInSelect3)} />}
            label="簽核查詢搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={checkStockInDetail3} onChange={handleCheckboxChange(setCheckStockInDetail3)} />}
            label="驗收入庫明細搜尋"
          />
          <FormControlLabel
            control={<Checkbox checked={approval} onChange={handleCheckboxChange(setApproval)} />}
            label="審核權"
          />
          <FormControlLabel
            control={<Checkbox checked={canCruduser} onChange={handleCheckboxChange(setCanCruduser)} />}
            label="可否更動帳號USER"
          />
        </FormGroup>
      </div>
      <div  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Button variant="contained" onClick={handleSave}>保存修改</Button>
      </div>
    </>
    }
  </>
)
};
